import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { DEFAULT_SETTINGS_SECTION_ID } from '@/data/settingsNavData'

const SettingsModalContext = createContext(null)

export function SettingsModalProvider({ children }) {
  const [open, setOpen] = useState(false)
  const [sectionId, setSectionId] = useState(DEFAULT_SETTINGS_SECTION_ID)

  const openSettings = useCallback((nextSectionId = DEFAULT_SETTINGS_SECTION_ID) => {
    setSectionId(nextSectionId)
    setOpen(true)
  }, [])

  const closeSettings = useCallback(() => {
    setOpen(false)
  }, [])

  const value = useMemo(
    () => ({ open, sectionId, setSectionId, openSettings, closeSettings }),
    [open, sectionId, openSettings, closeSettings],
  )

  return <SettingsModalContext.Provider value={value}>{children}</SettingsModalContext.Provider>
}

export function useSettingsModal() {
  const ctx = useContext(SettingsModalContext)
  if (!ctx) {
    throw new Error('useSettingsModal must be used within SettingsModalProvider')
  }
  return ctx
}
